import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LogService } from 'src/app/modules/shared/services/log.service';
import { SignatureType } from '../../models/SignatureType';
import { SignatureSessionService } from '../../services/signature-session.service';
import { SignatureParametersMessages } from '../../../shared/models/component-messages/signature-parameters-messages';

@Component({
  selector: 'app-signature-parameters',
  templateUrl: './signature-parameters.component.html',
  styleUrls: ['./signature-parameters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SignatureParametersComponent implements OnInit {

  public signatureParametersMessages = new SignatureParametersMessages();

  constructor(private signatureSession: SignatureSessionService, private LOG: LogService) {
  }

  public ngOnInit() {
    if (this.isXml()) {
      this.signatureSession.signatureRequestData.signatureTypeEnum = SignatureType.XADES;
    } else if (this.isPdf()) {
      this.signatureSession.signatureRequestData.signatureTypeEnum = SignatureType.PADES;
    } else {
      this.signatureSession.signatureRequestData.signatureTypeEnum = SignatureType.CADES_DETACHEE;
    }
  }

  public radioChecked(st: string) {
    this.signatureSession.signatureRequestData.signatureTypeEnum = SignatureType[st];
    this.LOG.log('[signatureType : {0}]', this.signatureSession.signatureRequestData.signatureTypeEnum);
  }

  public isXml(): boolean {
    return this.signatureSession.signatureRequestData.fileType === 'XML';
  }

  public isPdf(): boolean {
    return this.signatureSession.signatureRequestData.fileType === 'PDF';
  }
}
